import { render, staticRenderFns } from "./choiceContract.vue?vue&type=template&id=3a672b15&scoped=true&"
import script from "./choiceContract.vue?vue&type=script&lang=js&"
export * from "./choiceContract.vue?vue&type=script&lang=js&"
import style0 from "./choiceContract.vue?vue&type=style&index=0&id=3a672b15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a672b15",
  null
  
)

export default component.exports